import Splitting from 'splitting';
import { gsap } from '../global/gsap';

const initQuotes = (elements) => {
    elements.forEach((element) => {
        const quote = element.querySelector('blockquote');

        Splitting({
            /* target: String selector, Element, Array of Elements, or NodeList */
            target: quote,
            /* by: String of the plugin name */
            by: 'words'
        });

        const wordTotal = quote.style.getPropertyValue('--word-total');
        const words = quote.querySelectorAll('.word');

        const cite = element.querySelector('cite');

        if (cite) {
            cite.classList.add('hide');
        }

        gsap.to(words, {
            duration: 0.4,
            ease: 'linear',
            stagger: wordTotal * 0.001,
            color: '#ff84ee',
            scrollTrigger: {
                trigger: element,
                once: true,
                start: 'top 80%',
                invalidateOnRefresh: true
            },
            onComplete: () => {
                if (cite) {
                    cite.classList.remove('hide');
                }
            }
        });
    });
};

export { initQuotes as default };
